// extracted by mini-css-extract-plugin
var _1 = "gift_banner__RfHs-";
var _2 = "gift_container__ZTZqn";
var _3 = "gift_giftAmount__qHvPP";
var _4 = "gift_payment__J2G83";
var _5 = "gift_section__SPRhg";
var _6 = "gift_sectionBodyBottomBorder__HECMD";
var _7 = "gift_sectionTitle__N0kwW";
var _8 = "gift_sectionTitleImage__yS+W1";
var _9 = "gift_sectionTitleWithImage__V4ljL";
var _a = "gift_sendIt__si5l6";
var _b = "gift_sender__rVjOY";
var _c = "gift_subContainer__3T+C7";
var _d = "gift_title__R3gHH";
export { _1 as "banner", _2 as "container", _3 as "giftAmount", _4 as "payment", _5 as "section", _6 as "sectionBodyBottomBorder", _7 as "sectionTitle", _8 as "sectionTitleImage", _9 as "sectionTitleWithImage", _a as "sendIt", _b as "sender", _c as "subContainer", _d as "title" }
